import React from 'react';
import { useTranslation } from "react-i18next";
import { makeAjaxRequest } from "../common.js";

function LoginModal() {
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState("");
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    event.preventDefault();

    const userInfoJson = {
      password: password,
      username: username,
    };
    const callback = (result) => {
      window.location.reload();
    }
    makeAjaxRequest("/sa/login_ajax", userInfoJson, callback, setErrorMessage);
  };

  return (
  <div className="modal fade" id="loginModal" tabIndex="-1" aria-labelledby="loginModalLabel" aria-hidden="true">
  <div className="modal-dialog">
    <div className="modal-content rounded-4 shadow">
      <div className="modal-header p-5 pb-4 border-bottom-0">
        <h1 className="fw-bold mb-0 fs-2">{t('Login_FormTitle')}</h1>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div className="modal-body p-5 pt-0">
        <form onSubmit={handleSubmit}>
          <div className="form-floating mb-3">
            <input type="text" className="form-control rounded-3" id="loginUsername" required value={username} 
             placeholder="Username" onChange={(event) => setUsername(event.target.value)} />
            <label htmlFor="loginUsername">{t('Common_FieldUsername')}</label>
          </div>
          <div className="form-floating mb-3">
            <input type="password" className="form-control rounded-3" id="loginPassword" required value={password}
             placeholder="Password" onChange={(event) => setPassword(event.target.value)} />
            <label htmlFor="loginPassword">{t('Common_FieldPassword')}</label>
          </div>
          <button className="w-100 mb-2 btn btn-lg rounded-3 btn-primary" type="submit">{t('Common_ButtonLogin')}</button>
        </form>
        <div>{t('Login_NoAccount')}? <a href="#" data-bs-toggle="modal" data-bs-target="#signupModal">{t('Common_ButtonSignup')}</a></div>

        {errorMessage &&
        <div className="alert alert-danger" role="alert">{errorMessage}</div>
        }
      </div>
    </div>  
  </div>
  </div>
  );
};

export default LoginModal;
